import React from 'react';

import Text from '/component/base/Text';
import {Rank} from '/constant/TestIDs';
import {
  ASSOCIATE_DIRECTOR,
  DIRECTOR,
  EXECUTIVE_DIRECTOR,
  GLOBAL_DIRECTOR,
  MANAGER,
  NATIONAL_DIRECTOR,
  PRESIDENTIAL_DIRECTOR,
  REGIONAL_DIRECTOR,
} from '/enum/rank.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';

import DetailListItem from '../../DetailListItem';

const tt = (key: any, value: any) =>
  withTranslation.tt(`rankProgressCard.orderingEntities.${key}`, value);

export default {
  dataComponent: DetailListItem,
  dataComponentProps: {
    getTitle: ({current = 0, target = 0}) => {
      return target <= 1
        ? tt(
            'title.incomplete.singular',
            generateComponentCallback({
              component: (
                <Text allowFontScaling maxFontSizeMultiplier={2}>
                  {current}/{target} Qualifying Point
                </Text>
              ),
            }),
          )
        : tt(
            'title.incomplete.singular',
            generateComponentCallback({
              component: (
                <Text allowFontScaling maxFontSizeMultiplier={2}>
                  {current}/{target} Qualifying Points
                </Text>
              ),
            }),
          );
    },
  },
  extendedDataComponent: undefined,
  extendedDataComponentProps: {},
  isComplete: ({current, target}: any) => current >= target,
  hasExtendedDetail: false,
  presentedFor: [
    MANAGER,
    ASSOCIATE_DIRECTOR,
    DIRECTOR,
    EXECUTIVE_DIRECTOR,
    REGIONAL_DIRECTOR,
    NATIONAL_DIRECTOR,
    GLOBAL_DIRECTOR,
    PRESIDENTIAL_DIRECTOR,
  ],
  testID: Rank.rankQualifyingPoints,
};
